import React from 'react'
import { Box, Typography, TypographyProps, useTheme } from '@mui/material'
import LockIcon from '@mui/icons-material/Lock'

interface PositionAttributeAlertProps {
  message: string
  // Sin default: cada flujo pasa la variante que ya usa para sus mensajes/errores,
  // para no introducir un tamaño de fuente nuevo respecto a lo existente en esa pantalla.
  variant: TypographyProps['variant']
}

/**
 * Caja de aviso para los mensajes de atributos de posición (bloqueo de ingreso/egreso,
 * monosku, monolote, capacidad máxima) — WMSE-4510. No reemplaza los mensajes de error
 * genéricos (SKU no encontrado, posición no existe, etc.), que siguen con su estilo actual.
 */
export const PositionAttributeAlert: React.FC<PositionAttributeAlertProps> = ({
  message,
  variant
}) => {
  const theme = useTheme()
  return (
    <Box
      display='flex'
      alignItems='flex-start'
      gap={1}
      p={1.5}
      mt={1}
      sx={{
        backgroundColor: theme.palette.error.light + '20',
        border: `1px solid ${theme.palette.error.main}`,
        borderRadius: 1
      }}
    >
      <LockIcon fontSize='small' color='error' />
      <Typography
        variant={variant}
        style={{ color: theme.palette.error.dark, whiteSpace: 'pre-line' }}
      >
        {message}
      </Typography>
    </Box>
  )
}
